export const ROUTES = {
    HOME: '/',
    PROFILE: '/profile',
    PROMOTIONS: '/promotions',
    INTRODUCTION: '/introduction',
    DOWNLOAD: '/download',
    SOMETHING_WENT_WRONG: '/something_went_wrong',
    REDIRECT: '/redirect'
};
